import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import BenefitsSection from './components/BenefitsSection';
import ComparisonSection from './components/ComparisonSection';
import HowItWorksSection from './components/HowItWorksSection';
import ArticlesSection from './components/ArticlesSection';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import CTABannerSection from './components/CTABannerSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <BenefitsSection />
        <ComparisonSection />
        <HowItWorksSection />
        <ArticlesSection />
        <TestimonialSection />
        <FAQSection />
        <CTABannerSection />
      </main>
      <Footer />
    </>
  );
}